module.exports = __webpack_public_path__ + "img/icon-profile_member.9b92fa7b.png";